import styles from "./index.module.less";
import { Flex } from "antd";
import p2Img1 from "./imgs/p2_img1.png";
import p2Img2 from "./imgs/p2_img2.png";
import p2Img3 from "./imgs/p2_img3.png";
import p3Img1 from "./imgs/p3_img1.png";
import p3Img2 from "./imgs/p3_img2.png";
import p3Img3 from "./imgs/p3_img3.png";
import P3Icon1 from "./imgs/p3_icon1.svg?react";
import P3Icon2 from "./imgs/p3_icon2.svg?react";
import P3Icon3 from "./imgs/p3_icon3.svg?react";
import { useEffect, useMemo, useState } from "react";
import classNames from "classnames";
import P4Img1 from "./imgs/p4_img1.png";
import P1Content from "@/components/P1Content";
import data from "./data";
import { isMobile } from "@/utils";
import MobileAIBeings from "./mobile";

// 图片和icon映射
const p2Imgs = [p2Img1, p2Img2];
const p3Imgs = [p3Img1, p3Img2, p3Img3];
const p3Icons = [<P3Icon1 />, <P3Icon2 />, <P3Icon3 />];

const p3List = data.p3.list.map((item, idx) => ({
  ...item,
  img: p3Imgs[idx],
  icon: p3Icons[idx],
}));

const AIBeings = () => {
  const [activeAnchor, setActiveAnchor] = useState("");
  useEffect(() => {
    // 监听滚动事件，更新activeAnchor
    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight / 2;
      p3List.forEach((item) => {
        const element = document.getElementById(`feature-${item.anchor}`);
        if (element) {
          const rect = element.getBoundingClientRect();
          // 判断元素的中心出现在视口中间时，设置activeAnchor
          const elementCenter = rect.top + window.scrollY + rect.height / 2;
          if (
            elementCenter >= scrollPosition - 50 &&
            elementCenter <= scrollPosition + 50
          ) {
            setActiveAnchor(item.anchor);
          }
        }
      });
    };
    window.addEventListener("scroll", handleScroll);
    // 清理事件监听器
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const height = useMemo(() => {
    const barRect = document
      .querySelector(`.${styles.p3_left_bar}`)
      ?.getBoundingClientRect();
    const activeAnchorRect = document
      .getElementById(`nav-${activeAnchor}`)
      ?.getBoundingClientRect();
    const activeAnchorElement = document
      .querySelector(`#nav-${activeAnchor} .${styles.p3_left_text}`)
      ?.getBoundingClientRect();
    if (barRect && activeAnchorRect && activeAnchorElement) {
      const barTop = barRect.top;
      const activeAnchorTop = activeAnchorRect.top;
      return activeAnchorTop - barTop + activeAnchorElement.height / 2;
    }
  }, [activeAnchor]);
  return (
    <div className={styles.aiBeings}>
      <div className={styles.p1}>
        <P1Content
          title={data.p1.title}
          subtitle={data.p1.subtitle}
          link={data.p1.link}
        />
      </div>
      <div className={styles.p2}>
        <div className={styles.p2_inner}>
          <Flex gap={".35rem"} align="start">
            <Flex vertical align="start" className={styles.p2_texts}>
              <div className={styles.p2_title}>
                {data.p2.title}
                <br />
                <span>{data.p2.subtitle}</span>
              </div>
              {data.p2.desc.map((desc, i) => (
                <div className={styles.p2_desc} key={i}>
                  {desc}
                </div>
              ))}
            </Flex>
            <Flex
              align="start"
              justify="space-between"
              gap={".2rem"}
              className={styles.p2_imgs}
            >
              {p2Imgs.map((img, i) => (
                <div key={i} className={styles[`p2_img${i + 1}`]}>
                  <img src={img} alt="P2" />
                </div>
              ))}
            </Flex>
          </Flex>
        </div>
      </div>
      <div className={styles.p3}>
        <div className={styles.p3_inner}>
          <div className={styles.p3_left}>
            <div className={styles.p3_title}>{data.p3.title}</div>
            <div className={styles.p3_left_inner}>
              <div className={styles.p3_left_bar}>
                <div
                  className={styles.p3_left_bar_inner}
                  style={{
                    height: `${height}px`,
                  }}
                ></div>
              </div>
              <div className={styles.p3_left_navs}>
                {p3List.map((item, index) => (
                  <div
                    key={index}
                    onClick={() => {
                      const element = document.getElementById(
                        `feature-${item.anchor}`
                      );
                      if (element) {
                        element.scrollIntoView({
                          behavior: "smooth",
                          block: "center",
                        });
                      }
                    }}
                    style={{
                      color: activeAnchor === item.anchor ? "#000" : "#999",
                    }}
                    className={classNames(styles.p3_left_item, {
                      [styles.active]: activeAnchor === item.anchor,
                    })}
                    id={`nav-${item.anchor}`}
                  >
                    <Flex align="center" gap={8}>
                      {item.icon}
                      <span className={styles.p3_left_text}>{item.anchor}</span>
                    </Flex>
                    <div className={styles.p3_left_desc}>{item.desc}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className={styles.p3_right}>
            {p3List.map((item, index) => (
              <img id={`feature-${item.anchor}`} src={item.img} key={index} />
            ))}
          </div>
        </div>
      </div>
      <div className={styles.p4}>
        <div className={styles.p4_inner}>
          <div className={styles.p4_title}>
            {data.p4.title.split(data.p4.highlight)[0]}
            <span>{data.p4.highlight}</span>
            {data.p4.title.split(data.p4.highlight)[1]}
          </div>
          <img className={styles.p4_img} src={P4Img1} />
        </div>
      </div>
    </div>
  );
};
export default isMobile() ? MobileAIBeings : AIBeings;
